import ManageGroupViewers from './ManageGroupViewers'
import enhance from './ManageGroupViewers.enhancer'

export default enhance(ManageGroupViewers)

export const groupViewerTableColumns = [
  {
    width: 225,
    field: 'name',
    label: 'Name'
  },
  {
    width: 500,
    field: 'email',
    label: 'EMAIL',
  },
  {
    width: '100%', 
    field: 'select', 
    selectable: true, 
    align: 'flex-end',
    format: 'expandBox',
    selectableLabel: 'Remove from group'
  }
]



// WEBPACK FOOTER //
// ./src/containers/groups/ManageGroupViewers/index.js